import { createIntl, createIntlCache } from 'react-intl'
import { valuesForMessage as fixedDynamicParams } from './PortalMessage'
import enNBStrings from 'Translations/nb/lang-en.json'
import enAppStrings from 'Translations/uci/lang-en.json'

const cache = createIntlCache()

const translationMessages = {
  ...enNBStrings,
  ...(process.env.BANK === 'UCI' ? enAppStrings : {})
}

Object.keys(translationMessages).forEach(key => {
  const message = translationMessages[key]
  const updatedMessage = message.replace(/<br\s*\/?>/gi, '{br}')
  translationMessages[key] = updatedMessage
})

const intl = createIntl({
  locale: 'en',
  messages: translationMessages,
}, cache)

const flattenFormattedMessage = (message) => {
  if (typeof message === 'string') {
    return message;
  }

  if (Array.isArray(message)) {
    return message.map(flattenFormattedMessage).join('');
  }

  if (typeof message === 'object' && message.props && message.props.children) {
    return flattenFormattedMessage(message.props.children);
  }

  return '';
}

export const analyticsFormattedMessage = (message) => {
  if (!message) {
    return ''
  }
  const getMessage = { id: message.id, defaultMessage: message.defaultMessage }
  let valuesForMessage = { ...fixedDynamicParams }

  if (message.values) {
    valuesForMessage = { ...message.values, ...fixedDynamicParams }
  }
  const formattedMessage = intl.formatMessage(getMessage, valuesForMessage)
  return flattenFormattedMessage(formattedMessage)
}
